export const CLOUDINARY_CLOUD_NAME =
  process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || '';

export const CLOUDINARY_UPLOAD_PRESET =
  process.env.REACT_APP_CLOUDINARY_PRESET || '';

if (!CLOUDINARY_CLOUD_NAME) {
  // eslint-disable-next-line no-console
  console.warn(
    'Cloudinary cloud name is missing. Did you set REACT_APP_CLOUDINARY_CLOUD_NAME in .env.local?'
  );
}

if (!CLOUDINARY_UPLOAD_PRESET) {
  // eslint-disable-next-line no-console
  console.warn(
    'Cloudinary upload preset is missing. Did you set REACT_APP_CLOUDINARY_PRESET in .env.local?'
  );
}

// Helper function to upload to Cloudinary
export const uploadToCloudinary = (file, options = {}) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const formData = new FormData();

    formData.append('file', file);
    formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);

    // Add additional options
    Object.keys(options).forEach(key => {
      formData.append(key, options[key]);
    });

    // Determine the upload endpoint based on resource type
    const resourceType = options.resource_type || 'image';
    const uploadUrl = `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/${resourceType}/upload`;

    xhr.open('POST', uploadUrl);

    xhr.onload = () => {
      if (xhr.status === 200) {
        const response = JSON.parse(xhr.responseText);
        resolve(response.secure_url);
      } else {
        try {
          const error = JSON.parse(xhr.responseText);
          reject(new Error(error.error?.message || 'Upload failed'));
        } catch {
          reject(new Error(`Upload failed with status ${xhr.status}`));
        }
      }
    };

    xhr.onerror = () => {
      reject(new Error('Network error during upload'));
    };

    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        const percentComplete = (event.loaded / event.total) * 100;
        console.log(`Upload progress: ${percentComplete.toFixed(2)}%`);
      }
    };

    xhr.send(formData);
  });
};
